import { useState } from 'react';
import { FaCalendar, FaSignOutAlt } from 'react-icons/fa';
import { NavLink, useNavigate } from 'react-router-dom';
import { ReactComponent as UserIdCardIcon } from "../../assets/icons/userIdCard.svg";
import { ReactComponent as UserSettingIcon } from "../../assets/icons/userSetting.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/user.svg"
import './Ai2Sidebar.css';
import Ai2AccountToVironModal from './Ai2AccountToVironModal';

function Ai2Sidebar({ isOpen }) {
    const isAdmin = localStorage.getItem('isAdmin') === '1';
    const iscallcenter = localStorage.getItem('isCallCenter') === '1';
    const username = localStorage.getItem('username');
    const userId = localStorage.getItem('userId');
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();
    const [paymentStatus, setPaymentStatus] = useState('');
    const [referUserName, setReferUserName] = useState('');
    const [loading, setLoading] = useState(true);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/ai2/login');
    };


    return (
        <>

            <aside className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}>
                <ul className="sidebar-menu">
                    <li>
                        <NavLink to="/Ai2/Attendee/Center" className={({ isActive }) => isActive ? 'active' : ''}>
                            <UserSettingIcon /> <span><b className='text-red'>Ai<sup>2</sup></b> <b>ATTENDEE CENTER</b></span>
                        </NavLink>
                    </li>

                    <li className="disabled-link mt-2">
                        <div className="menu-item">
                            <UserIdCardIcon /> <span>Your <b className='text-red'>Ai<sup>2</sup></b> Username: <span className='text-light-blue'>{username}</span></span>
                        </div>
                    </li>
                    <li>
                        <NavLink to="/Ai2/CourseSchedule" className={({ isActive }) => isActive ? 'active' : ''}>
                            <FaCalendar /> <span>Select Available Course Schedule</span>
                        </NavLink>
                    </li>

                    {/* <li>
                        <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>
                            <FaCog /> <strong>Edit Your Account Information</strong>
                        </NavLink>
                    </li> */}

                    <li className="text-center">
                        <button className="active-viron-btn"
                            onClick={() => { setShowModal(true) }}
                        >
                            <UserIcon /> <span>Activate VIRON Account </span>
                        </button>
                    </li>

                    <li className="text-center">
                        <button className="logout-btn" onClick={handleLogout}>
                            <FaSignOutAlt /> <span>Logout</span>
                        </button>
                    </li>


                </ul>
            </aside>
            <Ai2AccountToVironModal
                show={showModal}
                onClose={() => setShowModal(false)}
                userId={userId}
            // calls API with selectedUserId
            />
        </>
    );
}

export default Ai2Sidebar;
